/**
 * AiExtractedInsuranceSuggestion - Displays AI-extracted insurance suggestion (read-only)
 */

import React from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Button,
} from '@roger/ui-components';
import { HelpCircle } from 'lucide-react';

export interface AiExtractedInsuranceSuggestionProps {
  /** The AI-extracted suggestion value */
  value: string | null | undefined;
  /** Custom label text (defaults to "AI-extracted suggestion") */
  label?: string;
  /** Custom help text for the popover */
  helpText?: string;
}

export const AiExtractedInsuranceSuggestion: React.FC<
  AiExtractedInsuranceSuggestionProps
> = ({
  value,
  label = 'AI-extracted suggestion',
  helpText = 'This is the insurance we extracted from the uploaded documents. Please double check and select the correct insurance configured for your agency in Kinnser above.',
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className='text-xs text-gray-500 mt-1 flex items-center gap-1'>
      <span>
        {label}: {value}
      </span>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant='ghost'
            size='sm'
            className='h-4 w-4 p-0 text-gray-400 hover:text-gray-600'
          >
            <HelpCircle className='h-3 w-3' />
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-80' align='start'>
          <div className='text-sm text-gray-700'>{helpText}</div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
